export const HubType = {
    spot: 'spot',
    festa: 'festa',
    stand: 'stand',
    studio: 'studio',
    schoomyers: 'schoomyers',
    crew: 'crew',
    stage: 'stage',
    in: 'in',
} as const;

export type HubType = (typeof HubType)[keyof typeof HubType];

export type HubTypeItem = {
    cd: string;
    name: string;
    name_en: string;
    is_visible_on_map: boolean;
};

export type HubTypeConfig = {
    type: HubType;
    label: string;
    icon: any;
    colorClass: string;
    isVisibleOnMap: boolean;
    mobileWidth: number;
    hoveredWidth: number;
};

export type HubMapItem = {
    hub_type: string;
    hub_index: string;
    hub_name: string;
    hub_sub_name: string;
    prefecture_name: string;
    lat: number;
    lng: number;
    country_cd: string;
    registration_status: string;
    is_online: boolean;
};

export type HubMapNewsItem = {
    hub_type: string;
    hub_index: string;
    hub_news_index: string;
    hub_name: string;
    hub_sub_name: string;
    title: string;
    description: string;
    url: string;
    eyecatch_resource_url: string;
    published_date: string;
    published_date_time: string;
};

export type HubNewsItem = {
    hub_type: string;
    hub_index: string;
    hub_news_index: string;
    hub_name: string;
    hub_sub_name: string;
    title: string;
    description: string;
    url: string;
    eyecatch_resource_url: string;
    published_date: string;
    published_date_time: string;
    tag_cds: string[];
};

export type HubNewsApiItem = Omit<HubNewsItem, 'hub_index' | 'hub_news_index'> & {
    hub_index: number;
    hub_news_index: number;
};

export type HubNewsTagItem = {
    cd: string;
    tag_category_cd: string;
    name: string;
    sort_order: number;
};

export type HubNewsTagCategoryItem = {
    cd: string;
    name: string;
    is_primary: boolean;
    sort_order: number;
    tags: HubNewsTagItem[];
};

/** Condition Types ──────────────────────────────────── */

export type HubNewsTagSelection = Record<string, string[]>;

/** Response ──────────────────────────────────────────── */

export type HubMapResponse = {
    hub_map_list: HubMapItem[];
    count: number;
};

export type HubMapNewsResponse = {
    hub_map_news_list: HubMapNewsItem[];
    count: number;
};

export type HubNewsResponse = {
    hub_news_list: HubNewsApiItem[];
    tag_category_list: HubNewsTagCategoryItem[];
    count: number;
};
